import { render, staticRenderFns } from "./ui-typography.vue?vue&type=template&id=1070822d&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1070822d')) {
      api.createRecord('1070822d', component.options)
    } else {
      api.reload('1070822d', component.options)
    }
    module.hot.accept("./ui-typography.vue?vue&type=template&id=1070822d&lang=pug&", function () {
      api.rerender('1070822d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-pages/ui-typography.vue"
export default component.exports